var textAligns = new Set(["left", "center", "right"]);
export default (function (_a) {
    var textAlign = _a.textAlign;
    return textAligns.has(textAlign) && "text-align: " + textAlign + ";";
});
